import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

//Material UI Imports
import {
  Avatar,
  Box,
  Grid,
  Tooltip,
  Typography,
} from '@mui/material';
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';
import StatCard from '../../../components/StatCard';
import StorageIcon from '@mui/icons-material/Storage';
   


const Centreon = () => {

  const [centreon, setCentreon] = useState([]);
    const { selectedOrganization } = useOrganizationSelect();
  

   const fetchCentreon = async () => {
       try {
           const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/centreon`);
            let filteredData = response.data.filter(item => item.deleted == null);
              if (selectedOrganization) {
               filteredData = response.data.filter(
                 (item) => item.organizationDetails?.name === selectedOrganization
               );
               }
           setCentreon(filteredData);

       } catch (error) {
           console.error('Error fetching Devices:', error);
       }
   };

   
  const formatValuecheckCritical = (value, critical) => {
    let formattedValue = value;
    if (typeof value === 'number') {
      formattedValue = value.toFixed(2).replace('.', ',');
    } else if (typeof value === 'string') {
      const num = parseFloat(value.replace(',', '.'));
      formattedValue = isNaN(num)
        ? value
        : num.toFixed(2).replace('.', ',');
    }
    const valueNum = parseFloat(
      typeof value === 'string'
        ? value.replace(',', '.')
        : value
    ) || 0;
    const criticalNum = parseFloat(
      typeof critical === 'string'
        ? critical.replace(',', '.')
        : critical
    ) || 0;
    const isOverCritical = valueNum > criticalNum;
    return { isOverCritical, formattedValue };
  }


   useEffect(() => {
    fetchCentreon();
   }, [selectedOrganization]);

    const columns = useMemo(
      () => [
        {
          id: 'centreon', //id used to define `group` column
            columns: [
            {
              accessorFn: (row) => row.name,
              id: 'name',
              header: 'Nom',
              Cell: ({ renderedCellValue }) => (
              <Box>{renderedCellValue}</Box>
              ),
            },
            {
              accessorFn: (row) => row.value,
              id: 'size',
              header: 'Taille (Go)',
              size: 50,
              Cell: ({ row, renderedCellValue }) => {

              const {isOverCritical, formattedValue} = formatValuecheckCritical(row.original.value, row.original.critical)
              return (
                <Box display="flex" alignItems="center" color={isOverCritical ? 'red' : 'inherit'}>
                {isOverCritical && (
                  <HighlightOffIcon fontSize="small" style={{ marginRight: 4 }} />
                )}
                {formattedValue}
                </Box>
              );
              },
            },
            // {
            //   accessorFn: (row) => row.warning,
            //   id: 'warning',
            //   header: 'Warning',
            //   Cell: ({ renderedCellValue }) => (
            //     <Box>{renderedCellValue}</Box>
            //   ),
            // },
            {
              accessorFn: (row) => row.critical,
              id: 'critical',
              header: 'Taille max (Go)',
              size: 50,

              Cell: ({ renderedCellValue }) => (
                <Box>{renderedCellValue}</Box>
              ),
            },
            {
              accessorFn: (row) => row.organizationDetails?.name,
              id: 'organizationDetailsName',
              header: 'Organization Name',
              Cell: ({ renderedCellValue }) => (
                <Box>{renderedCellValue}</Box>
              ),
            },
            {
              accessorFn: (row) => row.output,
              id: 'output',
              header: 'Output',
              Cell: ({ renderedCellValue }) => (
                <Box>{renderedCellValue}</Box>
              ),
            },
            {
              accessorFn: (row) => {
                const date = new Date(row.lastCheck);
                return `${date.toLocaleDateString('fr-FR')} ${date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`;
              },
              id: 'lastCheck',
              header: 'Last Check',
              Cell: ({ renderedCellValue }) => (
                <Box>{renderedCellValue}</Box>
              ),
            },
          ],
        },
      ],
      [],
    );
    
  
    const table = useMaterialReactTable({
      columns,
      data: centreon ? centreon : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      enableColumnFilterModes: true,
      enableColumnOrdering: true,
      enableGrouping: true,
      enableColumnPinning: true,
      enableFacetedValues: true,
      initialState: {
        density:"compact",
        // showColumnFilters: true,
        // showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
        pagination: {
          pageSize: 50,

        }
      },
      paginationDisplayMode: 'pages',
      positionToolbarAlertBanner: 'bottom',
      muiSearchTextFieldProps: {
        size: 'small',
        variant: 'outlined',
      },
      muiPaginationProps: {
        color: 'secondary',
        rowsPerPageOptions: [50, 100, 150],
        shape: 'rounded',
        variant: 'outlined',
      },
    });
  
  
    return (
    <Box>
      <Box my={2}>
         <Typography variant="h6" my={1}>Centreon</Typography>
          {/* <Grid container spacing={3}>
              <Grid item size={{ xs: 12, md: 3 }}>
                  <StatCard icon={<Avatar sx={{bgcolor:'#d32f2f'}}><StorageIcon /></Avatar>}  bgColor={'#ffebee'} borderColor={'1px solid #d32f2f'} title={"Surconsommation"} value={3} />
              </Grid>
          </Grid> */}
      </Box>
      <Box>
        <MaterialReactTable table={table}  />
      </Box>
    </Box> 
    )

};

export default Centreon;
